<script lang="ts">
	import { page } from '$app/stores';
	import Seo from '$lib/components/seo.svelte';
	import { t } from '$lib/i18n/translation';

	const lookupMap: { [statusCode: number]: string } = {
		404: 'error.page_not_found',
		401: 'unauthenticated',
		500: 'error.internal_error'
	};
</script>

<Seo title={$page.status in lookupMap ? lookupMap[$page.status] : 'error.general'} description="" noindex={true}></Seo>

<div class="container mx-auto max-w-[65ch] px-4 pt-24 grow">
	<div class="prose lg:prose-xl mb-20">
		<h1 class="text-error text-4xl text-center">
			{$t($page.status in lookupMap ? lookupMap[$page.status] : 'error.general')}<br />
			{$page.status}
		</h1>
	</div>
</div>
